import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer">
      <nav className="footer__links" aria-label="フッターナビゲーション">
        <Link to="/about">VRMA Hub について</Link>
        <Link to="/terms">利用規約</Link>
        <Link to="/privacy">プライバシーポリシー</Link>
        <Link to="/guidelines">コミュニティガイドライン</Link>
        <Link to="/rights">権利侵害の申告</Link>
        <Link to="/operator">運営者情報</Link>
        <Link to="/credits">クレジット・使用素材</Link>
        <a href="https://buymeacoffee.com/akunhu" target="_blank" rel="noopener noreferrer">
          開発を支援する
        </a>
      </nav>
      <span>© VRMA Hub Project</span>
    </footer>
  );
}
